export function createNudataScript(): void {
  if (!window.ndsapi) {
    window.ndsapi = {};
  }
  window.ndsReady = false;
  window.ndsReadyCallback = [];

  const nds = window.ndsapi;
  const baseUrl = `https://nd.chime.com/2.2/w/${process.env.NU_DATA_CLIENT_ID}/sync/js/`;
  nds.config = {
    q: [],
    ready: function (cb: () => void) {
      this.q.push(cb);
    },
  };

  const script = document.createElement('script');
  script.setAttribute('id', 'nudatascript');
  const firstScriptTagOnPage = document.getElementsByTagName('script')[0];
  script.src = baseUrl;
  firstScriptTagOnPage.parentNode.insertBefore(script, firstScriptTagOnPage);

  // need to set session id and replacement before the nds.load below
  nds.config.ready(function () {
    nds.setSessionId(window.crypto.randomUUID());

    window.ndsReady = true;
    for (let i = 0; i < window.ndsReadyCallback.length; i++) {
      window.ndsReadyCallback.shift()();
    }

    nds.setPlacement('RfaOrPa');
    nds.setPlacementPage(1);
  });

  script.onload = function () {
    nds.load(baseUrl);
  };
}
